<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="DEDICATION">To Members and Friends<br/> at the Westminster Presbyterian Church <br/>  in Grand Rapids, Michigan <br/>   where many of the ideas in this book <br/>    were first planted and a few blossomed.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Stewart_Envisioning_the_Congregation_text_CC1.vue?15231fdf